import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { combineLatest, Observable, take } from 'rxjs';

import { AuthorizationService } from '../authorization.service';

interface TabPermissionRouting {
  permissions: string[] | string;
  mode: 'any' | 'all';
  route: string;
}

// Todo: Remove this from here, the core folder should not contain components, directives or pipes
/**
 * This component is used to redirect the user to the correct child route based on their permissions.
 */
@Component({
  selector: 'app-permission-tab-redirect',
  imports: [RouterModule],
  templateUrl: './permission-tab-redirect.component.html',
  styleUrls: ['./permission-tab-redirect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
})
export class PermissionTabRedirectComponent implements OnInit {
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  authorizationService = inject(AuthorizationService);
  destroyRef = inject(DestroyRef);

  ngOnInit() {
    const routes = this.activatedRoute.snapshot.data['routes'] as TabPermissionRouting[];
    const routeChecks = routes.map(value => this.checkPermissions(value.permissions, value.mode));

    combineLatest(routeChecks)
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe(resultRoutes => {
        for (const [index, entry] of resultRoutes.entries()) {
          if (entry) {
            this.router.navigate([routes[index].route], { relativeTo: this.activatedRoute, replaceUrl: true });
            break;
          }
        }
      });
  }

  checkPermissions(permissions: string | string[], mode: 'any' | 'all'): Observable<boolean> {
    if (mode === 'any') {
      return this.authorizationService.userHasAnyPermission(permissions);
    } else {
      return this.authorizationService.userHasAllPermissions(permissions);
    }
  }
}

export const providePermissionTabRoutes = (...routeRules: TabPermissionRouting[]) => [...routeRules];
